import React, { useState } from "react";
import styled from "styled-components";
import Logo from "../images/HyperLogo2.png";

const Screen = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5em;
  /* Clear the phone's notch / camera cutout on the top edge. */
  padding-top: max(1.5em, env(safe-area-inset-top, 0px));
  box-sizing: border-box;
  color: #10242a;
  background: radial-gradient(
      circle at 18% 18%,
      rgba(24, 218, 142, 0.4),
      transparent 45%
    ),
    radial-gradient(circle at 85% 12%, rgba(14, 165, 165, 0.45), transparent 42%),
    linear-gradient(135deg, #06302e 0%, #0b5c58 48%, #0ea5a5 100%);
`;
const Card = styled.form`
  width: 360px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 2.4em 2.2em 2.6em;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
`;
const LogoImg = styled.img`
  height: 30px;
  width: auto;
  align-self: center;
  margin-bottom: 0.55em;
`;
const Kicker = styled.div`
  align-self: center;
  font-size: 0.72em;
  letter-spacing: 0.32em;
  text-transform: uppercase;
  font-weight: 700;
  color: #0ea5a5;
  margin-bottom: 0.4em;
`;
const Subtitle = styled.div`
  text-align: center;
  color: #5b6b70;
  margin-bottom: 1.9em;
  font-size: 0.95em;
`;
const Label = styled.label`
  font-size: 0.72em;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: #7b8a8f;
  margin-bottom: 0.45em;
`;
const Input = styled.input`
  background: rgba(9, 30, 33, 0.05);
  border: 1.5px solid rgba(9, 30, 33, 0.09);
  border-radius: 12px;
  padding: 0.85em 1em;
  font-size: 1em;
  color: #10242a;
  margin-bottom: 1.2em;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  &::placeholder {
    color: #9aa7ab;
  }
  &:focus {
    border-color: #0ea5a5;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(14, 165, 165, 0.15);
  }
`;
const Message = styled.div`
  color: #e0164b;
  font-weight: 600;
  text-align: center;
  min-height: 1.2em;
  margin-bottom: 0.7em;
  font-size: 0.9em;
`;
const Button = styled.button`
  border: none;
  border-radius: 12px;
  padding: 0.95em;
  font-size: 1.05em;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #04231a;
  cursor: pointer;
  background: linear-gradient(135deg, #18da8e 0%, #0ea5a5 100%);
  transition: transform 0.1s ease, filter 0.15s ease;
  &:hover {
    filter: brightness(1.05);
  }
  &:active {
    transform: translateY(1px);
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
    filter: none;
    transform: none;
  }
`;

export default function Login({ onSuccess }) {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/count/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user, pass }),
      });
      if (res.ok) {
        const body = await res.json().catch(() => ({}));
        onSuccess(body.peg);
        return;
      }
      setError("Incorrect username or password");
    } catch (err) {
      setError("Could not reach the server");
    }
    setLoading(false);
  }

  return (
    <Screen>
      <Card onSubmit={submit}>
        <LogoImg src={Logo} alt="Hyper" />
        <Kicker>Fish Count</Kicker>
        <Subtitle>Sign in to your peg</Subtitle>
        <Label htmlFor="login-user">Username</Label>
        <Input
          id="login-user"
          value={user}
          autoFocus
          autoCapitalize="none"
          autoCorrect="off"
          placeholder="e.g. peg5"
          onChange={(e) => setUser(e.target.value)}
        />
        <Label htmlFor="login-pass">Password</Label>
        <Input
          id="login-pass"
          type="password"
          value={pass}
          placeholder="••••••"
          onChange={(e) => setPass(e.target.value)}
        />
        <Message>{error}</Message>
        <Button type="submit" disabled={loading}>
          {loading ? "Signing in…" : "Sign In"}
        </Button>
      </Card>
    </Screen>
  );
}
